import { TRow } from '../components/Timeline/TimelineRow';

export const detectMostCommonRowColor = (row: TRow) => {
  const colorCounts: Record<string, number> = {};
  for (const clip of row.clips) {
    if (clip.color) {
      colorCounts[clip.color] = (colorCounts[clip.color] || 0) + 1;
    }
  }

  return Object.keys(colorCounts).length > 0
    ? Object.entries(colorCounts).reduce((prev, [color, count]) => (count > prev.count ? { color, count } : prev), { color: '', count: 0 })
        .color
    : '#7C7C72';
};
